var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTelaInicialNaoSelecionado({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 29.5V21.5C23.5 21.2348 23.3946 20.9804 23.2071 20.7929C23.0196 20.6054 22.7652 20.5 22.5 20.5H18.5C18.2348 20.5 17.9804 20.6054 17.7929 20.7929C17.6054 20.9804 17.5 21.2348 17.5 21.5V29.5",
    stroke: "#8E58BF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 18.5005C11.4999 18.2095 11.5633 17.9221 11.6858 17.6582C11.8082 17.3943 11.9868 17.1603 12.209 16.9725L19.209 10.9735C19.57 10.6684 20.0274 10.501 20.5 10.501C20.9726 10.501 21.43 10.6684 21.791 10.9735L28.791 16.9725C29.0132 17.1603 29.1918 17.3943 29.3142 17.6582C29.4367 17.9221 29.5001 18.2095 29.5 18.5005V27.5005C29.5 28.0309 29.2893 28.5396 28.9142 28.9147C28.5391 29.2897 28.0304 29.5005 27.5 29.5005H13.5C12.9696 29.5005 12.4609 29.2897 12.0858 28.9147C11.7107 28.5396 11.5 28.0309 11.5 27.5005V18.5005Z",
    stroke: "#8E58BF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelaInicialNaoSelecionado);
export default __webpack_public_path__ + "static/media/iconTelaInicialNaoSelecionado.0558a307c9f3080999930d52c5a7adb6.svg";
export { ForwardRef as ReactComponent };